<template>
  <div>
    <Head title="Multimedia" />

    <!-- Header -->
    <div class="flex items-center gap-4 mb-8">
      <h1 class="text-3xl font-bold">Multimedia</h1>
    </div>

    <!-- Export Section -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 class="text-xl font-semibold mb-4">Exportar Multimedia</h2>
      <p class="text-gray-600 mb-4">
        Descarga archivos ZIP con multimedia de la aplicación.
      </p>
      <div class="flex gap-4">
        <Link
          href="/media/export"
          class="btn-blue flex items-center gap-2"
        >
          <i class="fa fa-download"></i>
          <span>Exportar Todo</span>
        </Link>
        <Link
          href="/media/export/products"
          class="btn-blue flex items-center gap-2"
        >
          <i class="fa fa-image"></i>
          <span>Fotos de Productos</span>
        </Link>
      </div>
    </div>

    <!-- Import Section -->
    <div class="bg-white rounded-lg shadow-sm p-6">
      <h2 class="text-xl font-semibold mb-4">Importar Multimedia</h2>
      <p class="text-gray-600 mb-4">
        Sube un archivo ZIP con archivos multimedia para reemplazar los existentes.
      </p>
      <form @submit.prevent="submit" enctype="multipart/form-data">
        <div class="mb-4">
          <label for="file" class="block text-gray-700 mb-2">Archivo ZIP</label>
          <input
            type="file"
            id="file"
            ref="file"
            accept=".zip"
            class="form-input w-full"
            required
          />
        </div>
        <button
          type="submit"
          :disabled="processing"
          class="btn-blue flex items-center gap-2"
        >
          <i class="fa fa-upload"></i>
          <span>{{ processing ? 'Importando...' : 'Importar Multimedia' }}</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  name: 'MediaIndex',

  components: {
    Head,
    Link,
  },

  layout: Layout,

  data() {
    return {
      processing: false,
    }
  },

  methods: {
    submit() {
      this.processing = true
      const formData = new FormData()
      formData.append('file', this.$refs.file.files[0])

      this.$inertia.post('/media/import', formData, {
        onSuccess: () => {
          this.processing = false
          this.$refs.file.value = ''
        },
        onError: () => {
          this.processing = false
        }
      })
    },
  },
}
</script>